import { HelmetProvider } from 'react-helmet-async';

import { RouterProvider } from '@tanstack/react-router';

import { useTrackingInstallion } from '@/tracking/Tracking.hooks';

import './App.css';

import { router } from './App.router';

function App() {
	useTrackingInstallion();

	const classNames = ['App'];
	/*if (config.app.contentProtection) {
		classNames.push('content-protection');
		}*/

	return (
		<HelmetProvider>
			<div className={classNames.join(' ')}>
				<RouterProvider router={router} />
			</div>
		</HelmetProvider>
	);
}

export default App;
